import { useState, useEffect } from 'react'

interface User {
  email: string
  name: string
}

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)
  const [user, setUser] = useState<User | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Check if user is already logged in
    const storedAuth = localStorage.getItem('isAuthenticated')
    const storedUser = localStorage.getItem('user')

    if (storedAuth === 'true' && storedUser) {
      setIsAuthenticated(true)
      setUser(JSON.parse(storedUser))
    }
    setIsLoading(false)
  }, [])

  const login = (email: string, password: string) => {
    // Demo login - accepts any credentials
    const demoUser: User = {
      email,
      name: email.split('@')[0],
    }

    localStorage.setItem('isAuthenticated', 'true')
    localStorage.setItem('user', JSON.stringify(demoUser))
    setIsAuthenticated(true)
    setUser(demoUser)

    return true
  }

  const logout = () => {
    localStorage.removeItem('isAuthenticated')
    localStorage.removeItem('user')
    setIsAuthenticated(false)
    setUser(null)
  }

  return {
    isAuthenticated,
    user,
    isLoading,
    login,
    logout,
  }
}
